import { useEffect, useState } from "react";

/** Значение, отстающее от исходного на `delayMs` (для поиска по вводу). */
export function useDebounced<T>(value: T, delayMs = 250): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return v;
}

export default useDebounced;
